import { useState, useMemo } from "react";

type UsePaginationHook<T> = {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  totalPages: number;
  paginatedItems: T[] | null;
};

export function usePagination<T>(
  items: T[] | null,
  rowsPerPage: number = 12
): UsePaginationHook<T> {
  const [page, setPage] = useState(1);

  const totalPages = useMemo(() => {
    if (items == null) return 0;
    return Math.ceil(items.length / rowsPerPage);
  }, [items, rowsPerPage]);

  const paginatedItems = useMemo(() => {
    if (items == null) return null;
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return items.slice(start, end);
  }, [page, items, rowsPerPage]);

  return {
    page,
    setPage,
    rowsPerPage,
    totalPages,
    paginatedItems,
  };
}
